import { ReactNode, useEffect } from 'react';
import clsx from 'clsx';
import { fieldWidths } from './Form';

export type ErrorMessage = undefined | { message?: string } | string;

export interface ErrorProps {
  error?: ErrorMessage;
  onClear?: () => void;
  children?: ReactNode | ((error: string) => ReactNode);
  autoClose?: number | true | false;
  width?: keyof typeof fieldWidths;
}

const DEFAULT_ERROR_AUTOCLOSE = 5000;
const Error = ({ error, autoClose, children, onClear, width = 'full' }: ErrorProps) => {
  const message = typeof error === 'string' ? error : error?.message;
  useEffect(() => {
    if (!error) return;
    if (!onClear) return;
    if (autoClose === undefined || autoClose === true) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      autoClose = DEFAULT_ERROR_AUTOCLOSE;
    }
    if (autoClose === false || autoClose < 1) {
      return;
    }
    const timeout = setTimeout(onClear, autoClose);
    return () => clearTimeout(timeout);
  }, [error, autoClose, onClear]);

  if (!message) return <></>;
  return (
    <span className={clsx(fieldWidths[width], 'p-2 text-sm text-red-600 dark:text-red-400')}>
      {typeof children === 'function' ? children(message) : (children ?? message)}
    </span>
  );
};

export default Error;
